<template>
  <div class="animated fadeIn flex-row align-items-center member-profile">
    <div class="container">
      <b-card no-body>
        <b-tabs card vertical pills>
          <b-tab title="Account">
            <div class="text-center">
              <h3 class="m-0">Account</h3>
              <small
                >Edit your account settings and change your password here</small
              >
            </div>
            <hr />
            <b-form>
              <b-form-group label-cols-lg="4" label="Username">
                <b-form-input
                  v-model="model.username"
                  readonly=""
                ></b-form-input>
              </b-form-group>
              <b-form-group label-cols-lg="4" label="Email">
                <b-input-group>
                  <b-form-input
                    type="email"
                    v-model="model.email"
                    readonly=""
                  ></b-form-input>
                  <b-input-group-append>
                    <b-btn text="Button" variant="success">
                      <i class="fa fa-pencil"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group label-cols-lg="4" label="Mobile No">
                <b-input-group>
                  <b-form-input
                    v-model="model.mobile"
                    readonly=""
                  ></b-form-input>
                  <b-input-group-append>
                    <b-btn text="Button" variant="success">
                      <i class="fa fa-pencil"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <hr />
              <b-form-group label-cols-lg="4" label="Password">
                <b-form-input
                  type="password"
                  placeholder="Enter current password"
                  v-model="pwdObj.password"
                  :state="!$v.pwdObj.password.$error"
                ></b-form-input>
                <b-form-input
                  type="password"
                  placeholder="Enter new password"
                  class="mt-2"
                  v-model="pwdObj.new_password"
                  :state="!$v.pwdObj.new_password.$error"
                ></b-form-input>
                <b-form-input
                  type="password"
                  placeholder="Re-type new password"
                  class="mt-2"
                  v-model="pwdObj.confirm_password"
                  :state="!$v.pwdObj.confirm_password.$error"
                ></b-form-input>
              </b-form-group>
            </b-form>
            <hr />
            <div class="text-center">
              <b-button variant="danger" class="pl-4 pr-4" @click="changePwd()">
                <i class="fa fa-floppy-o mr-1"></i>
                Change Password
              </b-button>
            </div>
          </b-tab>

          <b-tab title="Personal Information">
            <div class="text-center">
              <h3 class="m-0">Personal Information</h3>
              <small>Add information about yourself</small>
            </div>
            <hr />
            <b-form>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Nama</label>
                  <div class="col-md-8">
                    <b-form-input
                      autofocus
                      :state="!$v.profile.crewname.$error"
                      required
                      v-model="profile.crewname"
                    ></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Tanggal Lahir</label>
                  <div class="col-md-8">
                    <b-form-input
                      type="date"
                      v-model="profile.crewdob"
                      :state="!$v.profile.crewdob.$error"
                    ></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Kota Lahir</label>
                  <div class="col-md-8">
                    <b-form-input v-model="profile.crewpob"
                    :state="!$v.profile.crewpob.$error"
                    ></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Jenis Kelamin</label>
                  <div class="col-md-8">
                    <b-form-radio-group
                      v-model="profile.crewmale"
                      :state="!$v.profile.crewmale.$error"
                      :options="genders"
                      plain
                      name="plain-inline"
                    ></b-form-radio-group>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Agama</label>
                  <div class="col-md-8">
                    <b-form-select
                      v-model="profile.religion"
                      :state="!$v.profile.religion.$error"
                      :plain="true"
                      :options="data.religions"
                    ></b-form-select>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Alamat</label>
                  <div class="col-md-8">
                    <b-form-input v-model="profile.crewaddr"
                    :state="!$v.profile.crewaddr.$error"
                    ></b-form-input>

                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label"></label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.crewaddr2"></b-form-input>
                  </div>
                </div>
              </div>

              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Province</label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.crewprovince"></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Kota</label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.crewcity"></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Kecamatan</label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.crewkecamatan"></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Kelurahan</label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.crewkelurahan"></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Kodepos</label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.crewpost"></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Pendidikan</label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.creweducation"></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Profesi</label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.crewprofession"></b-form-input>
                  </div>
                </div>
              </div>

              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">Nama Bank</label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.bankname"></b-form-input>
                  </div>
                </div>
              </div>
              <div class="b-form-group form-group">
                <div class="form-row">
                  <label class="col-md-4 col-form-label">No Rekening</label>
                  <div class="col-md-8">
                    <b-form-input v-model="model.bankaccno"></b-form-input>
                  </div>
                </div>
              </div>
            </b-form>
            <hr />
            <div class="text-center">
              <b-button
                variant="success"
                class="pl-4 pr-4"
                @click="savepersonalinfo()"
              >
                <i class="fa fa-floppy-o mr-1"></i>
                Save
              </b-button>
            </div>
          </b-tab>
          <b-tab title="Public Profile">
            <div class="text-center">
              <h3 class="m-0">Public Profile</h3>
              <small>Add a nice information of yourself for your profile</small>
            </div>
            <hr />
            <b-form>
              <b-form-group label-cols-lg="4" label="Image Preview">
                <image-uploader
                  :debug="0"
                  :maxWidth="160"
                  :maxHeight="100"
                  :maxSize="25.6"
                  :quality="1"
                  outputFormat="verbose"
                  :className="[
                    'fileInput',
                    { 'fileInput--loaded': imgUploader.hasImage },
                  ]"
                  :capture="false"
                  accept="image/*"
                  doNotResize="['gif', 'svg']"
                  @input="setImage"
                  ref="imgloader1"
                >
                  <label for="fileInput" slot="upload-label">
                    <figure>
                      <b-img
                        v-if="!profile.photo || !imgUploader.hasImage"
                        style="max-height: 300px"
                        thumbnail
                        fluid
                        src="img/no-image2.jpg"
                        alt="Thumbnail"
                        class="img-avatar"
                      />
                      <img
                        :src="profile.photo"
                        v-if="imgUploader.hasImage || profile.photo"
                       
                        
                        width="350"
                        height="350"
                      />

                      <!-- class="img-avatar" 
                          style="border: 1px solid #cecdcd;" -->
                    </figure>
                    <span class="upload-caption">
                      <i class="fa fa-file-image-o"></i>
                      {{ imgUploader.hasImage ? "Replace" : "Upload" }}
                    </span>
                  </label>
                </image-uploader>
              </b-form-group>
              <b-form-group
                label-cols-lg="4"
                class="mt-4"
                placeholder="Enter something"
                label="Profile Text"
              >
                <b-form-textarea :rows="6" :max-rows="10"></b-form-textarea>
              </b-form-group>
            </b-form>
            <hr />
            <div class="text-center">
              <b-button
                variant="success"
                class="pl-4 pr-4"
                @click="savepersonalinfo()"
              >
                <i class="fa fa-floppy-o mr-1"></i>
                Save
              </b-button>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<style lang="scss">
.member-profile {
  .tab-content {
    border: none;
    border-top: 1px solid #c8ced3;
  }
}
</style>

<script>
import moment from "moment";
import dropdown from "../data/dropdown";
import auth from "../apis/auth";
import crew from "../apis/crew";
import ImageUploader from "vue-image-upload-resize";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { ImageUploader },
  mixins: [validationMixin],
  validations: {
    model: {
      username: { required },
    },
    profile: {
      crewname: { required },
      crewdob: { required },
      crewpob: { required },
      crewmale: { required },
      religion: { required },
      crewaddr: { required },
    },
    pwdObj: {
      new_password: { required },
      confirm_password: { required },
      password: { required },
    },
  },
  data() {
    return {
      model: {
        religion: null,
        gender: null,
      },
      pwdObj: {},
      imgUploader: { hasImage: false, image: null },
      profile: { crewmale: 1, photo: '' },
      data: {
        genders: dropdown.genders,
        religions: dropdown.religions,
      },
      genders: [
        {
          text: " Male ",
          value: 1,
        },
        {
          text: " Female ",
          value: 0,
        },
      ],
    };
  },
  computed: {
    invalidPassword() {
      this.$v.pwdObj.$touch();
      return this.$v.pwdObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidProfile() {
      this.$v.profile.$touch();
      return this.$v.profile.$invalid;
    },
    file() {
      return this.model.file;
    },
  },
  created: async function () {
    this.model = await auth.me();
    const dtProfile = await crew.yourpersonalinformation();
    const this_ = this;
    for(const key in dtProfile){
      this_.profile[key] = dtProfile[key];
    }
    this.profile.photo = this.profile.photo || '';
    this.profile.crewkey = this.profile.crewkey || this.model.crewkey;
    this.profile.crewnik = this.profile.crewnik || this.model.crewnik;
    this.profile.crewname = this.profile.crewname || this.model.full_name;
    this.profile.crewdob =
      this.profile.crewdob != null
        ? moment(this.profile.crewdob).format("YYYY-MM-DD")
        : "";
    this.imgUploader.hasImage = this.profile.photo != null;

    // this.data.religions.unshift({
    //   text: " -- Pilih Agama -- ",
    //   value: null,
    // });
  },
  methods: {
    previewImage: function (event) {
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.profile.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    changePwd: async function () {
      if (this.invalidPassword) {
        toastr.error("Please fill the form correctly.", "Error Info");
      } else if (this.pwdObj.new_password !== this.pwdObj.confirm_password) {
        toastr.error("konfirmasi password tidak sama", "Error Info", 10000);
        return;
      } else if (this.pwdObj.new_password == this.pwdObj.password) {
        toastr.error(
          "password baru tidak boleh sama dengan password lama",
          "Error Info",
          10000
        );
        return;
      } else {
        try {
          this.pwdObj.username = this.model.username;
          await auth.change_password(this.pwdObj);
          toastr.success("Change Password Successfully");
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "Error Info", 10000);
          } else {
            toastr.error(JSON.stringify(error), "Error Info", 10000);
          }
        }
      }
    },
    setImage: function (output) {
      this.imgUploader.hasImage = true;
      this.imgUploader.image = output;
      this.profile.photo = this.imgUploader.image.dataUrl;
    },
    async savepersonalinfo() {
      try {
        if (this.invalidProfile) {
          toastr.error("Please fill the form correctly.", "Error Info");
        } else {
          await crew.savepersonalinfo(this.profile);
          toastr.success("Update personal information success.", "Info", 10000);
        }
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "Error Info", 10000);
        } else {
          toastr.error(JSON.stringify(error), "Error Info", 10000);
        }
      }
    },
  },
};
</script>
